import { useAccount } from 'wagmi'
import { zeroAddress } from 'viem'
import { useSetAtom } from 'jotai'
import { userAddressAtom } from 'services/atom/primitive/blockchain-calls/wallet'
import { walletConnectionStatusAtom } from '../services/atom/primitive/blockchain-calls/wallet'

/**
 * Problem: we need a hook at a high level to set the address atom based on the useAccount hook from wagmi.
 * Solution: create a hook that uses the useAccount hook and the useSetAtom hook to set the address atom.
 * This atom is then "listened to" by other atoms (like user balance atoms) and will automatically refetch data when the address
 * changes.
 */
export const walletSetup = () => {
  const { address, status } = useAccount()
  const setAddress = useSetAtom(userAddressAtom)
  const setStatus = useSetAtom(walletConnectionStatusAtom)

  setAddress(address ?? zeroAddress)
  setStatus(status)
}
